import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { Subscription } from 'rxjs';
import * as MobileDetect from 'mobile-detect';

import { Cloudinary, Util, XmStore, XmStoreUtil } from 'core/services';
import { CmsLevelMoveError } from 'store/cms/models';

@Component({
    selector: 'xm-level-move-error',
    templateUrl: './level-move-error.html',
    styleUrls: ['./level-move-error.scss'],
    standalone: false
})
export class XmLevelMoveError implements OnInit, OnDestroy {
    public pageData: CmslevelMoveErrorContent;
    public icon: MediaImageOptions;
    public isMobile: boolean;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];
    private state: StateService;
    private mobileDetect: MobileDetect = new MobileDetect(navigator.userAgent);

    constructor(xmStore: XmStore, state: StateService) {
        Object.assign(this, { xmStore, state });
    }

    public ngOnInit(): void {
        const errorCode: string = this.state.params.errorCode || 'default';
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsLevelMoveError>(CmsLevelMoveError), (result: CmsLevelMoveError) => {
            this.pageData = result.errors.find((content: CmslevelMoveErrorContent) => content.code === errorCode) || result.errors.find((content: CmslevelMoveErrorContent) => content.code === 'default');
            this.icon = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.icon)
            };
            this.isMobile = Boolean(this.mobileDetect.mobile());
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
